import React from "react";
import "swiper/modules/pagination/pagination.min.css";
import "swiper/swiper.min.css";
import { useTranslation } from "react-i18next";
import { Row } from "react-bootstrap";
import NoTemplate from "../../Assets/Animations/NoTemplate.json";
import LottiePlayer from "../LottiePlayer/lottiePlayer";

interface NoTemplatesProps {
  list?: boolean;
  sidebar?: boolean;
}

const NoTemplates: React.FC<NoTemplatesProps> = ({
  list = false,
  sidebar = false,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={`no-templates-wrap d-flex flex-column text-black justify-content-center align-items-center ${list ? "px-4" : ""} ${sidebar ? "px-2" : ""}`}>
        <Row className={`${list ? "w_16" : sidebar ? "w-100" : "w-90"} m-0 p-0`}>
          <LottiePlayer src={NoTemplate} />
        </Row>
        <Row className={`no-templates-title ${list ? "w_max text-center" : sidebar ? "w-100 text-center px-1" : "w_max"} SFMedium ${sidebar ? "text_18 justify-content-center sidebar-sec" : "text_18"}`}>{t("NoTemplateTitle")}</Row>
        <Row className={`no-templates-desc ${list ? "w_max text-center" : sidebar ? "w-100 text-center px-1" : "w_max"} SF mt-1 ${sidebar ? "text_16" : "text_16"}`}>{t("NoTemplateSubTitle")}</Row>
      </div>
    </>
  );
};

export default NoTemplates;
